import { UnitOfMeasureEnum } from "../../../api/Representation";
import { AccountsTypeEnum, FeeType } from "../../orders/api/Representation";
import { DayOfWeekEnum } from "../../sendersReceivers/api/Representation";
export var LoadRateCalcMethodEnum;
(function (LoadRateCalcMethodEnum) {
    LoadRateCalcMethodEnum["AUTO"] = "AUTO";
    LoadRateCalcMethodEnum["MANUAL"] = "MANUAL";
})(LoadRateCalcMethodEnum || (LoadRateCalcMethodEnum = {}));
export var VehicleHirePaymentMethodEnum;
(function (VehicleHirePaymentMethodEnum) {
    VehicleHirePaymentMethodEnum["HOUR"] = "HOUR";
    VehicleHirePaymentMethodEnum["LOAD"] = "LOAD";
    VehicleHirePaymentMethodEnum["CONSIGNMENT"] = "CONSIGNMENT";
})(VehicleHirePaymentMethodEnum || (VehicleHirePaymentMethodEnum = {}));
export var VehicleHireStatusEnum;
(function (VehicleHireStatusEnum) {
    VehicleHireStatusEnum["WITHHELD"] = "WITHHELD";
    VehicleHireStatusEnum["ON_MARKET"] = "ON_MARKET";
    VehicleHireStatusEnum["ALLOCATED"] = "ALLOCATED";
    VehicleHireStatusEnum["STARTED"] = "STARTED";
    VehicleHireStatusEnum["CANCELLED"] = "CANCELLED";
    VehicleHireStatusEnum["COMPLETED"] = "COMPLETED";
})(VehicleHireStatusEnum || (VehicleHireStatusEnum = {}));
export var VehicleHireLocationTypeEnum;
(function (VehicleHireLocationTypeEnum) {
    VehicleHireLocationTypeEnum["STARTING"] = "STARTING";
    VehicleHireLocationTypeEnum["DELIVERY"] = "DELIVERY";
})(VehicleHireLocationTypeEnum || (VehicleHireLocationTypeEnum = {}));
export var PaymentApprovalStageEnum;
(function (PaymentApprovalStageEnum) {
    PaymentApprovalStageEnum["PENDING"] = "PENDING";
    PaymentApprovalStageEnum["APPROVED"] = "APPROVED";
    PaymentApprovalStageEnum["REJECTED"] = "REJECTED";
    PaymentApprovalStageEnum["PAID"] = "PAID";
})(PaymentApprovalStageEnum || (PaymentApprovalStageEnum = {}));
export var TemplateScheduleRecurrenceEnum;
(function (TemplateScheduleRecurrenceEnum) {
    TemplateScheduleRecurrenceEnum["FREQUENCY"] = "FREQUENCY";
    TemplateScheduleRecurrenceEnum["ON_DAYS"] = "ON_DAYS";
})(TemplateScheduleRecurrenceEnum || (TemplateScheduleRecurrenceEnum = {}));
export var ScheduleFrequencyEnum;
(function (ScheduleFrequencyEnum) {
    ScheduleFrequencyEnum["DAILY"] = "DAILY";
    ScheduleFrequencyEnum["DAILY_EX_WEEKEND"] = "DAILY_EX_WEEKEND";
    ScheduleFrequencyEnum["WEEKLY"] = "WEEKLY";
    ScheduleFrequencyEnum["MONTHLY"] = "MONTHLY";
    ScheduleFrequencyEnum["YEARLY"] = "YEARLY";
})(ScheduleFrequencyEnum || (ScheduleFrequencyEnum = {}));
export class VehicleHireLocationTransformer {
    static toWaypoint(response) {
        if (!response) {
            return undefined;
        }
        return {
            companyName: response.companyName,
            contactName: response.contactName,
            contactTelephone: response.contactTelephone,
            contactEmail: response.contactEmail,
            address: response.address,
            sourcedSenderReceiverId: response.sourcedSenderReceiverId
        };
    }
}
